
    /**
    * 新增分享
    **/
      
  import request, {AxiosPromise} from '@utils/request'
  /**
 * BdShareInfoSaveParam :BdShareInfoSaveParam
 */
export class IReqid18645 {
  /**
   * bd账号
   */
  bdCode?: {};
  /**
   * 分享链接
   */
  shareUrl?: {};
  /**
   * 链接唯一标识
   */
  urlUniqueNo?: {};
}
  /**
 * YResult :YResult
 */
export class IResid18645 {
  code?: {};
  msg?: {};
  success?: {};
  exceptionMsg?: {};
}
  type Serve<T, G> = (data?: T) => AxiosPromise<G>
  const http: Serve<IReqid18645, IResid18645 > = (data?) =>  request({
        method: 'POST',
        url: '/admin/bdShareInfo/save_bd_share_info',
        data: data
      }) 
  export default http